import React from "react";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function Performance() {
  return <SidebarLayout title="Performance">Performance</SidebarLayout>;
}
